import { useState } from "react";
import { useDispatch } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import { searchedByText } from "../../features/tasks/tasksSlice";

const SearchInput = () => {
  const [text, setText] = useState("");

  const dispatch = useDispatch();

  const match = useMatch("/");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setText(e.target.value);
    dispatch(searchedByText(e.target.value));
    if (!match) navigate("/");
  };

  return (
    <div className="flex-1 max-w-xs search-field group">
      <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
      <input
        type="text"
        placeholder="Search Task"
        className="search-input"
        id="lws-searchTask"
        value={text}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchInput;
